import { useTranslation } from 'next-i18next'
import { Box, ButtonIcon, IconClose } from '@machobear/design-system'

const ClearButton = ({ onClick = () => {} }) => {
  const { t } = useTranslation()
  return (
    <Box position="absolute" style={{ top: 10, right: 28 }}>
      <ButtonIcon
        id="clear-address"
        label={t('landlords:Clear Address', 'Clear Address')}
        icon={<IconClose />}
        onClick={onClick}
      />
    </Box>
  )
}

export default ClearButton
